"use client";

import React, { useState } from "react";
import AniCard from "../primitives/AniCard";
import AniCheckbox from "../primitives/AniCheckbox";
import AniDivider from "../primitives/AniDivider";
import AniTag from "../primitives/AniTag";
import AniAvatarGroup from "../primitives/AniAvatarGroup";

type Task = {
  id: string;
  label: string;
  group: "Design" | "Meet";
  done: boolean;
};

const INITIAL_TASKS: Task[] = [
  { id: "t1", label: "Task 1", group: "Design", done: true },
  { id: "t2", label: "Task 2", group: "Meet", done: false },
  { id: "t3", label: "Task 3", group: "Design", done: false },
];

const GROUPS: Array<Task["group"]> = ["Design", "Meet"];

const AniTaskCard = () => {
  const [tasks, setTasks] = useState(INITIAL_TASKS);
  const remaining = tasks.filter((task) => !task.done).length;

  return (
    <AniCard className="ani-task-card">
      <h4 className="ani-task-title">Team Daily Task</h4>

      <div className="ani-task-tags" data-structure="Status tags" data-gap="spacing/xxs">
        {GROUPS.map((group) => (
          <AniTag key={group}>
            {group}
          </AniTag>
        ))}
      </div>

      <AniDivider />

      <ul className="ani-task-list" data-structure="Task list" data-gap="spacing/xs">
        {tasks.map((task) => (
          <li key={task.id}>
            <AniCheckbox
              checked={task.done}
              label={task.label}
              onChange={(next) =>
                setTasks((current) =>
                  current.map((item) =>
                    item.id === task.id ? { ...item, done: next } : item,
                  ),
                )
              }
            />
          </li>
        ))}
      </ul>

      <AniDivider />

      <AniAvatarGroup
        people={["Ana Reis", "Bruno Sá", "Caio Lima", "Duda Melo"]}
      />
      <p className="sr-only" aria-live="polite">
        {remaining === 0 ? "All done for today" : `${remaining} left today`}
      </p>
    </AniCard>
  );
};

export default AniTaskCard;
